import * as React from 'preact/compat'
import Modal from '../components/Modal'
import { showModal } from '../common/helpers'

export default (elements: NodeListOf<HTMLAnchorElement|HTMLButtonElement>) => {
  elements.forEach((element) => {
    element.addEventListener('click', () => {
      const template = document.querySelector<HTMLElement>(element.getAttribute('data-static-modal'))
      let content: HTMLElement
      if (template instanceof HTMLTemplateElement) {
        content = template.content.cloneNode(true) as HTMLElement
      } else {
        content = template.cloneNode(true) as HTMLElement
      }

      showModal(({ onClose }) => <Modal onClose={onClose} showClose child={content} />)
    })
  })
}
